import rawAxios from 'axios';
import moment from 'moment';
import { createAxios } from '../lib/axiosFactory';
import { ActionResponse } from '../lib/interfaces/actionResponse';
import { errorParser } from '../lib/response/errorParser';
import { uuid } from '../lib/utilities/uuid';
import { VuexLocalStorage } from '../lib/vuexLocalStorage';

const storage = new VuexLocalStorage('_UPLOAD_');

export const state = {};

export const mutations = {};

export const getters = {};

export const actions = {
  async loadSasToken(
    { rootState },
    { blobName, container }
  ): Promise<ActionResponse> {
    try {
      const response = await createAxios().post(
        '/backend/sas-tokens-create',
        {
          data: {
            type: 'sasTokens',
            attributes: {
              container: container,
              blobName: blobName
            }
          }
        },
        {
          params: {
            clientId: rootState.user.clientId
          }
        }
      );
      return {
        success: true,
        errors: {},
        body: response.data.data.attributes
      };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },
  async uploadToSas(
    context,
    { file, uri }: { uri: string; file: File }
  ): Promise<ActionResponse> {
    try {
      /**
       * @link https://docs.microsoft.com/en-us/rest/api/storageservices/put-blob
       */
      const response = await rawAxios.put(uri, file, {
        headers: {
          'Content-Type': file.type,
          'x-ms-blob-type': 'BlockBlob'
        }
      });
      return {
        success: true,
        errors: {},
        body: response.data
      };
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },
  generateFilePath(context, fileName: string, subDirectory = ''): string {
    const date = moment().format('YYYY-MM-DD');
    const clientId = context.rootState.user.clientId;
    if (subDirectory)
      return `${clientId}/${subDirectory}/${date}/${uuid()}_${fileName}`;
    return `${clientId}/${date}/${uuid()}_${fileName}`;
  }
};
